"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customFilterButtonClass = exports.StyledFilterButton = exports.SearchWrapper = exports.PickupPointsDialogContent = exports.PickupPointsDialog = exports.LayoutTab = exports.Header = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _shared = require("../shared");
const PickupPointsDialog = exports.PickupPointsDialog = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  [`& .${_mui.tabClasses.root}.${_mui.tabClasses.root}`]: {
    // making the default tab top padding smaller, as there is enough padding around
    // the searchbox, and we need it there
    paddingTop: 0
  },
  [`& .${_components.dialogClasses.dialogGrid}`]: {
    height: '100%',
    maxHeight: 661,
    width: `calc(100vw - ${theme.spacing(12)})`,
    gridTemplateAreas: `
      "header header header"
      "content content content"
    `,
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'calc(100% - 60px)'
    }
  },
  [`& .${_components.dialogClasses.header}`]: {
    padding: theme.spacing(0),
    [theme.breakpoints.only('xs')]: {
      padding: theme.spacing(0)
    }
  },
  [`& .${_components.dialogClasses.backButton}`]: {
    height: 45,
    margin: theme.spacing(6, 3, 6, 5),
    width: 45,
    zIndex: 2,
    [theme.breakpoints.only('xs')]: {
      height: 35,
      margin: theme.spacing(5, 1),
      width: 35
    }
  }
}));
const LayoutTab = exports.LayoutTab = (0, _mui.styled)(_mui.Tab)({
  '&&': {
    marginRight: 0
  }
});
const Header = exports.Header = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column'
});
const SearchWrapper = exports.SearchWrapper = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isInstantResultOpened
  }
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  zIndex: 1,
  ...(isInstantResultOpened && {
    borderBottom: `1px solid ${theme.palette.divider}`
  })
}));
const customFilterButtonClass = exports.customFilterButtonClass = 'delivery-filter-button';
const StyledFilterButton = exports.StyledFilterButton = (0, _mui.styled)(_shared.FilterButton)(({
  theme
}) => ({
  [`&.${customFilterButtonClass}`]: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(5),
    [theme.breakpoints.only('xs')]: {
      marginRight: theme.spacing(1)
    }
  }
}));
const PickupPointsDialogContent = exports.PickupPointsDialogContent = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isInstantResultOpened,
    isMapLayoutShown
  }
}) => ({
  background: theme.palette.background.paper,
  height: '100%',
  // Hiding scrollbars on content top level container so that the list / map tab switching
  // works without map rendering "jumps". Scrolling is moved down 1 level to subelements.
  overflow: 'hidden',
  overscrollBehavior: 'contain',
  position: 'relative',
  [theme.breakpoints.only('xs')]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    ...(isMapLayoutShown && !isInstantResultOpened && {
      padding: 0
    })
  }
}));